import axios from 'axios';

const instance = axios.create({
  baseURL: import.meta.env.VITE_DIDOX_API_URL_3,
});

export const getTimestamp = (signatureHex: string, pkcs7: string) =>
  instance.post(`/v1/dsvs/timestamp`, { signatureHex, pkcs7 });

type JoinSigResponse =
  | { success: false; message: string }
  | { success: true; pkcs7B64: string };

export const joinSignatures = (signature1: string, signature2: string) =>
  instance.post<JoinSigResponse>(`/v1/dsvs/signature/join`, {
    signature1,
    signature2,
  });
